module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Bluetooth-80557792f0f1da4314dbf38ff3b9b89d.svg";